import { createPalette } from 'styles/theme/colors';
import overrides from 'styles/theme/overrides';
import typography from 'styles/theme/typography';
import fonts from 'styles/theme/fonts';
import constants from 'styles/theme/constants';

export default {
  constants,
  createPalette,
  fonts,
  overrides,
  typography
};
